<template>
  <!-- 회원유형 선택 -->
  <v-bottom-sheet
    v-model="sheet"
    scrollable
    persistent
    no-click-animation
    :overlay-opacity="0.7"
    content-class="bottom-sheet"
  >
    <v-card>
        <v-card-title class="justify-space-between">
            <div class="fs-22 fw-700 lightBlack--text mb-2">회원유형 선택</div>
			<v-btn icon  @click="sheetClose"> <Close /></v-btn>
        </v-card-title>
        <v-card-text  class="sheet-body">
            <div class="fs-18 lightBlack--text mb-8">가입하실 회원유형을 선택하세요.</div>
            <v-radio-group
                v-model="division"
                mandatory
                active-class="active"
                hide-details="true">
                <v-radio
                    label="일반회원"
                    value="02"
                    class="radio"
					@click="goToPage" />
                <v-radio
                    label="기업회원"
                    value="01"
                    class="radio"
					@click="goToPage" />
          </v-radio-group>

        </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close';
export default {
	
  props: {
    sheet: Boolean,
  },
    data: ()=> ({
		division : ''
    }),
	methods: {
		goToPage() {
			this.$router.push({name: '약관동의', params: {'division': this.division}})
		},
		sheetClose() {
			this.sheet = false;
		},
	},
  computed:{
  },
  components: {
    Close
  },

};
</script>
<style lang="scss" scoped>
::v-deep .v-dialog{
  .v-card__title{
    padding-bottom: 0px !important;
  }
  .v-card__text{
    padding-bottom: 50px;
  }
}
::v-deep .radio {
    margin-bottom: 20px !important;
    .v-input--selection-controls__input {
      display: none;
    }
    .v-label {
      height: 48px !important;
      border: 1px solid #E6E8EA;
      border-radius: $border-radius-root;
      color: $color-main;
      justify-content: center;
    }
    &.active {
      .v-label {
        background: #000;
        color: #fff;
      }
    }
}
</style>